import { ProviderAst } from '@angular/compiler';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogsService {

  constructor() { }

  getCardProviders() {
    let ProvidersList = [
      {
        name: 'Visa',
        providerId: 1
      },
      {
        name: 'Cacao',
        providerId: 2
      },
      {
        name: 'Blackhawk',
        providerId: 3
      },
    ];
    return ProvidersList;
  }

  getCardBrands(){
    let cardBrands = [
      {name:'Visa'},
      {name:'Master  Card'},
      {name:'Amex'},
      {name:'Carnet'},
    ];
    return cardBrands;
  }

  getCardTypes(){
    let cardTypes = [
      {name: 'Black', id: 1},
      {name: 'Gold', id: 2},
      {name: 'Blue', id: 3},
      {name: 'Orange', id: 4},
    ];
    return cardTypes;
  }
}
